export const getStoriesMediaTypes = () =>  [
    {
        label: "Картинка",
        value: "picture"
    },
    {
        label: "Видео",
        value: "video"
    }
];